<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<img alt="titlepage.jpg" src="images/titlepage_fmt.jpeg"/>
<p class="link"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="link"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?162aa06e